import { Navbar } from "@/components/Navbar";
import { CartDrawer } from "@/components/CartDrawer";
import { Footer } from "@/components/Footer";

const POINTS = [
  ["Uno strumento, non un trainer", "L'intelligenza artificiale mi aiuta in alcune attività, ma non prende decisioni al posto mio. Il tuo programma, le correzioni e i consigli arrivano da me, da una persona che conosce la tua storia."],
  ["Dove non la uso", "Il test di anamnesi lo leggo io, personalmente. Le valutazioni sul tuo percorso non sono affidate a un algoritmo."],
  ["Trasparenza", "Quando un risultato è prodotto dall'IA, nel sito lo trovi indicato in modo chiaro, così sai sempre da dove arriva un'informazione."],
  ["Limiti", "L'IA può sbagliare. Non sostituisce il parere di medici, psicologi o dietisti, e non la uso per diagnosi o indicazioni cliniche."],
];

export default function EthicalAI() {
  return (
    <main data-testid="ethical-ai-page">
      <Navbar />
      <CartDrawer />
      <section className="px-5 pb-24 pt-28 md:px-10 md:pt-36">
        <div className="mx-auto max-w-[1100px]">
          <p className="eyebrow mb-6">Tecnologia al servizio della persona</p>
          <h1 className="font-display text-5xl font-900 uppercase leading-[0.85] md:text-8xl">Uso etico dell'IA<span className="text-[#c4dcca]">.</span></h1>
          <p data-testid="ethical-ai-intro" className="mt-8 max-w-2xl text-base leading-relaxed text-[#a3b1aa] md:text-lg">
            Ormai l'intelligenza artificiale fa parte delle nostre vite. Il mio obiettivo è usarla e dare l'esempio: l'IA può essere uno strumento al servizio delle persone, se usata consapevolmente. Per questo la uso quando mi aiuta a seguirti meglio, mai per sostituire il rapporto umano su cui si basa il percorso.
          </p>
          <ol className="mt-14 divide-y divide-white/10 border-y border-white/10" data-testid="ethical-ai-list">
            {POINTS.map(([title, text], i) => (
              <li key={title} data-testid={`ethical-ai-point-${i}`} className="grid gap-3 py-8 md:grid-cols-[1fr_2fr] md:gap-10">
                <p className="font-display text-xl font-800 uppercase leading-tight text-[#98bfa2] md:text-2xl">{title}</p>
                <p className="text-base leading-relaxed text-[#a3b1aa] md:text-lg">{text}</p>
              </li>
            ))}
          </ol>
        </div>
      </section>
      <Footer />
    </main>
  );
}
